import * as SplashScreen from "expo-splash-screen";

export const displaySplash = () => {
  SplashScreen.preventAutoHideAsync();
  SplashScreen.setOptions({
    fade: true,
  });
};

export const hideSplash = () => {
  SplashScreen.hide();
};
